import TrainingFinished from "./TrainingFinished";

export default TrainingFinished;
